import React from 'react';
import { motion } from 'framer-motion';
import { FiPhone, FiMail } from 'react-icons/fi'; 
import { Link } from 'react-router-dom';
import fotterlogo from "../Asserts/fotterlogo.png";

function Footer() {
  return (
    <div className='bg-[#FF6F00] py-8 px-5 md:px-10 lg:px-20'>
      <div className='flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10'>
        
        {/* Left Section - Logo and Details */}
        <motion.div 
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className='space-y-4 md:text-center lg:text-left'
        >
          <img src={fotterlogo} alt="Logo" className='w-48  lg:mx-0' />
          <p className='text-sm text-white'>
            KOTA HOLDINGS <br />
            Flat #2 & 3, Kota Chambers<br />
            GK Towers, Dwarakanagar<br />
            Visakhapatnam, Andhra Pradesh, 530016
          </p>
          <p className="text-sm text-white flex items-center justify-center lg:justify-start">
  <FiMail className="mr-1" />
  <span className="mr-1">Mail:</span>
  <a href="mailto:venkatareddy.k@kotaholdings.in" className="font-bold underline">
    venkatareddy.k@kotaholdings.in
  </a>
</p>

<p className="text-sm text-white flex lg:justify-start">
  <FiPhone className="mr-1" />
  <span className="mr-1">Call:</span>
  <a href="tel:+919991577577" className="font-bold">
    +91 9991 577 577
  </a>
</p>
        </motion.div>

        {/* Right Section - Navigation Links */}
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className='w-full flex flex-wrap justify-between gap-8 lg:gap-20 '
        >
          {[{
            title: 'Company',
            links: [{ name: 'About Us', path: '/about' }, { name: 'Privacy Policy', path: '/privacy' }]
          }, {
            title: 'Loans',
            links: [
              { name: 'Home Loan', path: '/HomeLoanPage' },
              { name: 'Personal Loan', path: '/PersonalLoanPage' },
              { name: 'Business Loan', path: '/BusinessLoanPage' },
              { name: 'Education Loan', path: '/EducationLoanPage' },
              { name: 'Car Loan', path: '/CarLoanPage' }
            ]
          }, {
            title: 'Insurance',
            links: [
              { name: 'Life Insurance', path: '/LifeInsurance' },
              { name: 'Health Insurance', path: '/HealthInsurance' }
            ]
          }, {
            title: 'DSA',
            links: [
              { name: 'Personal Loan DSA', path: '/PersonalLoanDsa' },
              { name: 'Home Loan DSA', path: '/HomeloanDsa' },
              { name: 'Business Loan DSA', path: '/BusinessLoanDsa' }
            ]
          }].map((section, index) => (
            <div key={index} className='w-1/2 sm:w-auto'>
              <ul className='text-white space-y-1'>
                <li className='font-bold mb-2'>{section.title}</li>
                {section.links.map((link, i) => (
                  <li key={i}><Link to={link.path}>{link.name}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </motion.div>
      </div>
      
      <hr className='mt-8 border-white' />

      {/* Footer Bottom */}
      <div className='text-white flex flex-col sm:flex-row gap-2 text-center justify-center items-center mt-4'>
        <p>©2025 - Kota Holdings All Rights Reserved</p>
        <a href='https://sconexsoft.com/' target='_blank' rel='noopener noreferrer'>Sponsored by Sconex Software Solutions</a>
      </div>
    </div>
  );
}

export default Footer;
